import { makeStyles } from 'tss-react/mui';
import {darkGrey} from "../../../../globalStyle";

const useStyles = makeStyles()((theme) => ({
    root: {
        marginBottom: "40px",
        "& .dossierInfoPaper": {
            padding: "1rem"
        },
        "& .completenessPaper": {
            padding: "1rem"
        },
        "& .dossierBtns": {
            display: "flex",
            justifyContent: "flex-end"
        },
        "& .deactivateBtn": {
            backgroundColor: darkGrey,
            color: "white",
            marginRight: "0.5rem"
        },
    },

    // Top header
    topHeaderIcon: {
        marginRight: "5px",

        "&:nth-of-type(2)":{
            marginLeft: "16px",
        }
    },
    smallIcon: {
        width: "11px",
        height: "10px"
    },
    marginLeft: {
        marginLeft: "15px"
    },
    thirdpartyName: {
        color: theme.palette.primary.primary800,
    },
    topHeaderLabelActivity: {
      fontWeight: 700,
      color: theme.palette.primary.primary400,
    },
    topHeaderLabelActivityArchived: {
        fontWeight: 700,
        color: theme.palette.grey.grey300,
    },
    archiveButton: {
        marginRight: "0.5rem",
        color: theme.palette.grey.grey600,
        backgroundColor: theme.palette.grey.grey200,
        borderRadius: "16px",
        padding: "11px 16px",
        textTransform: "none",
        fontWeight: 600,
        fontFamily: "Inter",
        fontSize: "12px",
        boxShadow: "0px 11.28px 24.231px rgba(154, 154, 175, 0.115017), 0px 6.0308px 12.9551px rgba(154, 154, 175, 0.0953772), 0px 3.38082px 7.2625px rgba(154, 154, 175, 0.08), 0px 1.79553px 3.85706px rgba(154, 154, 175, 0.0646228), 0px 0.747159px 1.60501px rgba(154, 154, 175, 0.0449833)",

        "&:hover": {
            backgroundColor: theme.palette.grey.grey300,
        },
    },
    archiveButtonIon: {
      marginRight: "0.5rem",
    },
    archivedThemeHeader: {
      color: "white",
    },
    archivedBtnLabel:{
        textTransform: "none",
        position: "relative",
    },
    addedDate: {
        fontSize: "12px",
    },

    overlay: {
        position: "absolute",
        left: "-25px",
        right: "-24px",
        top: "-24px",
        bottom: "-24px"
    },
    // Header Tab
    tab: {
        fontWeight: 600,
        borderRadius: '18px 18px 0 0',
        minWidth: "146px",
        height: "39px",
        marginRight: "2px",
        backgroundColor: "white",
        zIndex: 1,
        textTransform: "none",
        fontSize: "16px",
        fontFamily: "Inter",
        padding: "10px 7px",
    },
    selectedTab: {
        color: "black !important",
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 13px 27px -10px, rgba(0, 0, 0, 0.3) 0px 8px 13px -9px",
    },
    unselectedTab: {
        color: theme.palette.grey.grey400,
        opacity: 0.75,

        "& MuiTabs-scroller": {
            position: "absolute"
        },
    },

    // Header background
    headerBackground: {
        minHeight: "183px",
        background: "no-repeat 100% 100% url('../../../../img/background/thirdpartyBG.png')",
        backgroundSize: 'cover',
        backgroundColor: "#302e31",
        padding: "24px",
        width: "100%",
    },

    headerBackgroundNoTheme: {
        minHeight: "183px",
        background: "no-repeat 100% 100% url('../../../../img/background/thirdpartyArchivedBG.png')",
        backgroundSize: 'cover',
        backgroundColor: "#302e31",
        padding: "24px",
        width: "100%",
    },

    // Info of document (missing/ok)
    documentsInfo: {
        marginTop: "20px",
        marginBottom: "20px",
        zIndex: 2,
        padding: "0rem !important",
    },

    // Utils
    backToFront: {
        zIndex: 2,
    },
    tpItem: {
        margin: "16px 16px 0 16px"
    },
    marginTab: {
        backgroundColor: "white",
        borderRadius: "0 12px 12px 12px",
    },
    tabDisabled: {
        opacity: 0.75,
        background: "#E2E2EABF",
    },
    tpNameWrapper: {
        display: "flex",
        gap: "10px",
        alignItems: "center",
    },
    navigationAncreWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: "sticky",
        zIndex: 3,
        backdropFilter: "blur(10.499999046325684px)",
        overflowX: "auto",
        maxWidth: "calc(100vw - 250px)",
        overflowY: "hidden",

        // TODO si on ne veux pas afficher la barre de scroll
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        scrollbarWidth: 'none',
        '-ms-overflow-style': 'none',
    },
    navigationAncreItemsWrapper: {
        backgroundColor: theme.palette.primary.primary50,
        borderRadius: "42px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "5px 10px",
        margin: "16px 16px 0 16px",
        maxWidth: "calc(-280px + 100vw)",
    },
    navigationAncreItem: {
        color: theme.palette.primary.primary800,
        fontWeight: 600,
        fontSize: "12px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        cursor: "pointer",
        whiteSpace: 'nowrap',
        padding: "4px 12px",
        transition: 'color 0.3s ease, border-radius 0.3s ease, background-color 0.3s ease',
    },
    navigationAncreItemActive: {
        color: theme.palette.primary.primary800,
        fontWeight: 600,
        fontSize: "12px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        cursor: "pointer",
        whiteSpace: 'nowrap',

        backgroundColor: theme.palette.primary.primary300,
        padding: "4px 12px",
        borderRadius: "30px",
        transition: 'color 0.3s ease, background-color 0.3s ease, transform 0.3s ease',
        transform: 'scale(1.05)',
    },
    burgerWrapper: {
        marginLeft: "24px",
        marginRight: "10px",
        cursor: "pointer",
        position: "relative",
        top: "6px"
    },
    burgerItemText: {
        fontSize: "14px",
        color: "#7E7E8F"
    },
    activityLabelWrapper: {
        display: "flex",
        flexDirection: "row",
        gap: "13px",
        flexWrap: "wrap",
        marginBottom: "14px",
    },
    idChip: {
        backgroundColor: "rgba(255, 255, 255, 0.40)",
        fontColor: "#656575",
        fontSize: "10px",
        fontWeight: 700,
        padding: "4px 10px",
        borderRadius: "16px",
        border: "1px solid white",
        color: "white"
    },
    adresseIdentifiersMoreDetailsWrapper: {
        display: "flex",
        alignItems: "space-between",
        justifyContent: "space-between",
        gap: "13px",
        flexWrap: "wrap",
        position: 'relative',
        top: "16px",
    },
    adresseIdentifiersWrapper: {
        flex: "1",
        display: "flex",
        gap: "13px",
        flexWrap: "wrap",
        position: 'relative',
        top: "0px"
    },
    typoLineWrapper: {
        display: "flex",
        alignItems: "center",
        position: "relative",
        top: "1px"
    },
    typoContent: {
        fontSize: "12px",
        color: "white",
        // textDecoration: "underline",
        marginLeft: "4px",
    },
    typoLabel: {
        fontSize: "13px",
        color: "#C6CBD9",
        position: "relative",
        top: "-1px"
    },
    idChipWrapper: {
        display: "flex",
        flexDirection: "row",
        gap: "4px",
        cursor: "pointer",
        flexWrap: "nowrap",
    },
    moreDetailsWrapper: {
        cursor: "pointer",
        color: "white",
        padding: "0 5px",
        zIndex: 20,
        maxHeight: "25px",

        "&:hover" : {
            backgroundColor: "white",
            borderRadius: "12px",
            color: "black",
        }
    },
    moreDetailsText: {
        fontSize: "12px",
        fontWeight: "600",
    },
    tpCodeWrapper: {
        cursor: "pointer",
        color: "white",
        fontSize: "12px",
    },
    tpCodeDisabled: {
                color: "white",
        fontSize: "12px",
    },
    tpCodeIcon: {
        width: "14px",
        position: "relative",
        top: "2px",
        marginLeft: "4px",
    },
    informationsTitleWrapper: {
        paddingTop: "16px", paddingLeft: "16px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
    },
    informationsEtablissement: {
        backgroundColor: theme.palette.primary.primary100,
        fontSize: "16px",
        fontWeight: "600",
        padding: "9px",
        borderRadius: "8px",
        display: 'flex',
        alignItems: 'center'
    },
    separatorHeader: {
        borderColor: '#E2E2EA',
        marginTop: '10px',
        marginBottom: '10px',
        position: "relative",
        left: "-24px",
        top: "18px"
    },
    archiveReasonWrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#7E7E8F",
        color: "#F2F3F7",
        padding: "14px",
        borderRadius: "12px",
        marginRight: "10px",
    },
    archiveReasonWrapperOnSheet: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#7E7E8F",
        color: "#F2F3F7",
        padding: "14px",
        borderRadius: "12px",
        marginRight: "10px",
        position: "relative",
        top: "50px",
        left: "-25px",
        marginBottom: "25px",
    },
    archiveReasonTitleWrapper: {
        display: "flex",
        alignItems: "center",
    },
    archiveReasonTitle: {
        fontSize: "22px",
        fontWeight: "600",
    },
    archiveReasonTextWrapper: {
        fontSize: "14px",
    },
}));

export default useStyles;
